<template>
    <div>
       <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="商品名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="商品简称">
            <el-input v-model="form.shortname"></el-input>
         </el-form-item>
          <el-form-item label="商品简介">
             <el-input v-model="form.desc"></el-input>
          </el-form-item>
          <el-form-item label="商品价格">
            <el-input v-model="form.price"></el-input>
          </el-form-item>
          <el-form-item label="直升等级">
            <el-select v-model="form.tolevel" placeholder="请选择直升等级">
              <el-option
                v-for="item in levellist"
                :key="item.levelval"
                :label="item.levelname"
                :value="item.levelval">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="包含商品">
            <div style='display:inline-block;'>
              <el-input placeholder="请输入商品数量" v-model="goodsnums" class="input-with-select">
                        <el-select v-model="goodsid" slot="prepend" placeholder="请选择商品">
                           <el-option v-for="item in goodslist" :key="item.id" :label="item.name" :value="item.id" ></el-option>
                        </el-select>
                        <el-button slot="append" icon="el-icon-plus" @click='addGoodsItem()'>添加</el-button>
              </el-input>
            </div>
            <el-table
              :data="form.goodsdetail"
              style="width: 100%">
              <el-table-column
                prop="goodsname"
                label="名称"
              >
              </el-table-column>
              <el-table-column
                prop="goodsnums"
                label="数量"
                >
              </el-table-column>
              <el-table-column
                label="操作">
                <template slot-scope="scope">
                  <el-button
                  size="mini"
                  type="danger"
                  @click="delGoodsItem(scope.row.goodsid)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="商品库存">
             <el-input v-model="form.stock"></el-input>
          </el-form-item>
          <el-form-item label="封面图">
              <el-upload
                :action="uploadImgUrl"
                name='image'
                :data="{extra:'headimg',type:'goods_headimg'}"
                list-type="picture-card"
                :limit='1'
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-success='handleUploadOK'
                :on-exceed='handleExceed'
                :file-list="filelist['headimg']"	
                >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
          </el-form-item>
          <el-form-item label="轮播图">
            <el-upload
              :action="uploadImgUrl"
              name='image'
              :data="{extra:'slides',type:'slides'}"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-success='handleUploadOK'
              :on-exceed='handleExceed'
              :file-list="filelist['slides']"	
              >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
        </el-form-item>
          <el-form-item label="内容介绍">
            <vue-ueditor-wrap v-model="form.content" :config="uEditConfig"></vue-ueditor-wrap>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSave">立即保存</el-button>
            <el-button @click='goBack'>取消</el-button>
          </el-form-item>
        </el-form>
    </div>  
</template>

<script>
  import VueUeditorWrap from 'vue-ueditor-wrap' 
  export default {
    components: {
          VueUeditorWrap
    },
    data() {
      const uEditorUrl=process.env.VUE_APP_UEDITOR_SERVERURL+'?token='+this.$store.state.user.token
      return {
        form: {
          id:'',
          name: '',
          shortname:'',
          desc: '',
          price:'',
          stock:'',
          ishot:false,
          headimg:[],
          goodsdetail:[],
          slides:[],
          tolevel:''
        },
        uploadImgUrl:process.env.VUE_APP_API+"/upload/uploadImg",
        dialogImageUrl: '',
        dialogVisible: false,
        processing:false,
        filelist:[],

        goodslist:[],
        goodsid:'',
        goodsnums:'',
        levellist:'',
        gmap:{},

        uEditConfig: {
                  initialFrameHeight: 240,
                  initialFrameWidth: '100%',
                  serverUrl: uEditorUrl,
                  UEDITOR_HOME_URL: './plugins/UEditor/'
        }
      }
    },
    created(){
          this.form.id=this.$route.query.goodsid==undefined?0:this.$route.query.goodsid
          this.initGoodsInfo(this.form.id)
    },
    methods: {
      onSave() {
          if(this.processing){
             this.$message.error("请等待处理完成");return false
          }
          if(this.form.name==''){
            this.$message.error("商品名称不能为空");return false
          }
          if(this.form.shortname==''){
            this.$message.error("商品简称不能为空");return false
          }
          if(this.form.desc==''){
            this.$message.error("商品简介不能为空");return false
          }
          if(this.form.price==''|| isNaN(this.form.price) || parseInt(this.form.price)<=0){
            this.$message.error("商品价格设置有误");return false
          }
          if(this.form.tolevel==""){
            this.$message.error("请选择直升等级");return false
          }
          if(this.form.goodsdetail.length<=0){
            this.$message.error("请选择包含商品");return false
          }
          if(this.form.stock==''|| isNaN(this.form.stock) || parseInt(this.form.stock)<0){
            this.$message.error("商品库存设置有误");return false
          }
          if(this.form.headimg.length<1){
            this.$message.error("请上传商品缩略图片");return false
          }

          if(this.form.slides.length<1){
            this.$message.error("请上传商品轮播图");return false
          }
          if(this.form.content==''){
            this.$message.error("内容介绍不能为空");return false
          }
          this.form.headimg=this.form.headimg[0]
          this.form.ishot=0
         
          this.processing=true
          this.$post("/goods/saveDGoods",{goodsinfo:this.form}).then((data)=>{
               if(data.result.success){
                   this.$message({message:data.result.info,type:'success'})
                   setTimeout(()=>{this.$router.push('/dgoodslist')},500)
               }else{
                   this.$message.error(data.result.info)
               }
               this.processing=false
          })
      },
      initGoodsInfo(goodsid){
          this.$post("/goods/getDGoodsInfo",{goodsid:goodsid}).then((data)=>{
             if(this.form.id>0){
                this.form=data.result.info.goodsinfo
             }
             this.filelist=data.result.info.filelist
             this.goodslist=data.result.info.goodslist
             this.gmap=data.result.info.gmap
             this.levellist=data.result.info.levellist
          })
      },
      addGoodsItem(){
          if(this.goodsid==''||isNaN(this.goodsid)||this.goodsid<=0){
            this.$message.error("请先选择要添加的商品");return false;
          }
          if(this.goodsnums==''||isNaN(this.goodsnums)||this.goodsnums<=0){
            this.$message.error("请输入商品数量");return false;
          }
          if(this.form.goodsdetail.find(element=>element.goodsid==this.goodsid)!=undefined){
            this.$message.error("已包含此商品");return false;
          }
          this.form.goodsdetail.push({goodsid:this.goodsid,goodsnums:this.goodsnums,goodsname:this.gmap[this.goodsid]})
          this.goodsid=''
          this.goodsnums=''
      },
      delGoodsItem(goodsid){
        this.form.goodsdetail=this.form.goodsdetail.filter(item=>item.goodsid!=goodsid)
      },
      goBack(){
          this.$go("/dgoodslist")
      },
      handleRemove(file, fileList) {
        let type=file.response.result.info.extra
        switch(type){
          case 'headimg':
                this.form.headimg=this.getSlides(fileList);break;
          case 'slides':
                this.form.slides=this.getSlides(fileList);break;  
          default:
                this.$message("图片类型错误");      
        }
      },
      handleUploadOK(response, file, fileList){
        let type=response.result.info.extra
        switch(type){
          case 'headimg':  
                this.form.headimg=this.getSlides(fileList);break;    
          case 'slides':
                this.form.slides=this.getSlides(fileList);break;
          default:
                this.$message("图片类型错误");      
        }
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      getSlides(fileList){
         return fileList.map((item)=>item.response.result.info.url)
      },
      handleExceed(){
         this.$message.error("超出最大上传数量");
      }  
    }
  }
</script>

<style scoped lang="scss">

</style>
